export default {
      id: "kjott-usage",
      viewBox: "0 0 124 68",
      url: __webpack_public_path__ + "/gfx/iconset.13.17.6.svg#kjott",
      toString: function () {
        return this.url;
      }
    }